class CartValueBanner extends HTMLElement {
  connectedCallback() {
    this.threshold = parseInt(this.dataset.threshold, 10); // cents
    this._excludedIds = undefined;

    const closeBtn = this.querySelector('.cart-value-banner__close');
    if (closeBtn) closeBtn.addEventListener('click', () => this.dismiss());

    if (Shopify.designMode) {
      if (this.dataset.showInCustomizer === 'true') this.setState('unlocked');
      return;
    }

    this.checkAndUpdate();
    this.observeCartChanges();
  }

  async getExcludedIds() {
    if (this._excludedIds !== undefined) return this._excludedIds;
    const handle = this.dataset.excludedCollection;
    if (!handle) { this._excludedIds = []; return []; }
    try {
      const { products } = await fetch(`/collections/${handle}/products.json?limit=250`).then(r => r.json());
      this._excludedIds = products.map(p => p.id);
    } catch (e) { this._excludedIds = []; }
    return this._excludedIds;
  }

  async checkAndUpdate() {
    try {
      const [{ items }, excludedIds] = await Promise.all([
        fetch('/cart.js').then(r => r.json()),
        this.getExcludedIds()
      ]);
      let excludedUnitUsed = false;
      const adjustedTotal = items.reduce((sum, item) => {
        if (!excludedUnitUsed && excludedIds.includes(item.product_id)) {
          excludedUnitUsed = true;
          return sum + item.final_line_price - item.final_price;
        }
        return sum + item.final_line_price;
      }, 0);

      if (adjustedTotal >= this.threshold && excludedUnitUsed) {
        this.setState('hidden');
      } else if (adjustedTotal >= this.threshold) {
        if (sessionStorage.getItem('cvb_dismissed') === '1') {
          this.setState('hidden');
        } else {
          this.setState('unlocked');
        }
      } else if (adjustedTotal > 0) {
        this.updateProgress(adjustedTotal);
        this.setState('progress');
      } else {
        this.setState('hidden');
      }
    } catch (e) {
      console.error('[CartValueBanner]', e);
    }
  }

  updateProgress(adjustedTotal) {
    const remaining = Math.max(this.threshold - adjustedTotal, 0);
    const pct = Math.min((adjustedTotal / this.threshold) * 100, 100);

    const remainingEl = this.querySelector('.cvb-progress__remaining');
    if (remainingEl) {
      const currency = window.Shopify?.currency?.active || 'USD';
      remainingEl.textContent = (remaining / 100).toLocaleString('en-US', {
        style: 'currency',
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      });
    }

    const fill = this.querySelector('[data-progress-line]');
    if (fill) fill.style.width = `${pct}%`;
  }

  setState(state) {
    // data-shows="progress" constrains element to only show the progress state
    // data-shows="unlocked" constrains element to only show the unlocked state
    // no data-shows = shows both (cart page unified element)
    const shows = this.dataset.shows;
    let effective = state;
    if (shows === 'progress' && state !== 'progress') effective = 'hidden';
    if (shows === 'unlocked' && state !== 'unlocked') effective = 'hidden';

    this.dataset.state = effective;
    this.setAttribute('aria-hidden', effective === 'hidden' ? 'true' : 'false');
  }

  dismiss() {
    sessionStorage.setItem('cvb_dismissed', '1');
    this.setState('hidden');
  }

  observeCartChanges() {
    const targets = [
      ...document.querySelectorAll('.cart-count-badge'),
      ...document.querySelectorAll('[data-cart-total-price]')
    ];
    if (!targets.length) return;
    const observer = new MutationObserver(() => this.checkAndUpdate());
    targets.forEach(el => observer.observe(el, {
      childList: true, subtree: true, characterData: true,
      attributes: true, attributeFilter: ['data-cart-total-price']
    }));
  }
}

if (!customElements.get('cart-value-banner')) {
  customElements.define('cart-value-banner', CartValueBanner);
}
